//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { BatchBillingProfileInputItem } from './BatchBillingProfileInputItem';
import { BatchBillingProfileUpdateItem } from './BatchBillingProfileUpdateItem';
import { BatchBillingProfileDeleteOption } from './BatchBillingProfileDeleteOption';

export class BatchBillingProfileUpdateItems extends ItemBase {
    InputItems: BatchBillingProfileInputItem[] = [];
    UpdateItems: BatchBillingProfileUpdateItem[] = [];
    DeleteItems: BatchBillingProfileDeleteOption[] = [];

    constructor(initializer?: Partial<BatchBillingProfileUpdateItems>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BatchBillingProfileUpdateItems";
}
